function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M13.412 2l-.707.707-5 5-.707.707-.708-.707-4.998-5L.585 2 1.999.586l.707.707 4.292 4.293 4.293-4.293.707-.707L13.412 2z",
  fill: "currentColor"
});

var SvgExpand = function SvgExpand(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 9,
    fill: "#A7AEB7"
  }, props), _ref);
};

export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTQiIGhlaWdodD0iOSIgdmlld0JveD0iMCAwIDE0IDkiIGZpbGw9IiNBN0FFQjciIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjxwYXRoIGZpbGwtcnVsZT0iZXZlbm9kZCIgY2xpcC1ydWxlPSJldmVub2RkIiBkPSJNMTMuNDExOSAxLjk5OTk3TDEyLjcwNDggMi43MDcwN0w3LjcwNDgyIDcuNzA3MDlMNi45OTc2MSA4LjQxNDNMNi4yOTA1IDcuNzA2OTlMMS4yOTE5NiAyLjcwNjk4TDAuNTg0OTYxIDEuOTk5NzdMMS45OTkzOCAwLjU4NTc2MkwyLjcwNjM5IDEuMjkyOTdMNi45OTc4MSA1LjU4NTY2TDExLjI5MDYgMS4yOTI4NkwxMS45OTc3IDAuNTg1NzU0TDEzLjQxMTkgMS45OTk5N1oiIGZpbGw9ImN1cnJlbnRDb2xvciIvPgo8L3N2Zz4K";
export { SvgExpand as ReactComponent };